import http from 'hub-http/clients/apiClient';
import PortalIdParser from 'PortalIdParser';
export const fetchHubsInfo = () => {
  const portalId = PortalIdParser.get();
  return http.get(`hubs2/v1/info/hub/${portalId}`);
};